import { render, staticRenderFns } from "./anchor.vue?vue&type=template&id=772c75c7&scoped=true"
import script from "./anchor.vue?vue&type=script&lang=js"
export * from "./anchor.vue?vue&type=script&lang=js"
import style0 from "./anchor.vue?vue&type=style&index=0&id=772c75c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772c75c7",
  null
  
)

export default component.exports